import { render, staticRenderFns } from "./RedactorPreorderBriefPanel.vue?vue&type=template&id=d4a38062&"
import script from "./RedactorPreorderBriefPanel.vue?vue&type=script&lang=js&"
export * from "./RedactorPreorderBriefPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports